<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
    <core-upsell-product-card
      v-for="product in displayProducts"
      :key="product.sku"
      :product="product"
      category="Permanent Storage"
      :title="`${product.storageSize} GB`"
      :suffix="isMonthlyPayment ? ' USD/per month' : ' USD'"
      :description="isMonthlyPayment ? '24 monthly installments' : 'Pay once. Never pay again!'"
      :featured="product.sku === featuredSku"
      :loading="isAddingToCart"
      @cta="emit('addToCart', product)"
      cta-label="Protect My Memories"
    />
  </div>
</template>

<script setup>
  const props = defineProps({
    products: {
      type: Array,
      required: true
    },
    isMonthlyPayment: {
      type: Boolean,
      default: false
    },
    isAddingToCart: Boolean,
    featuredSku: String
  });

  const emit = defineEmits(['addToCart']);

  const displayProducts = computed(() => props.products.map(product => ({
    ...product,
    storageSize: parseInt(product.name)
  })));
</script>
